<style lang="less" scoped>
  .download {
    margin:30px auto 50px;
    width: 1240px;
    height: 100%;
    position: relative;
    .bgImg{
      width: 1240px;
      min-height:660px;
      background: url('../../assets/imgs/down1.png') no-repeat;
      background-size: 100% 100%;
      position: relative;
      .loadType{
        display: flex;
        position: absolute;
        left: 130px;
        top: 480px;
        .ios{
          .ios_img{
            width: 140px;
            height: 140px;
          }
          .text{
            text-align: center;
            font-size: 18px;
            font-weight: 600;
            line-height: 36px;
          }
        }
        .android{
          margin-left: 20px;
          .android_img{
            width: 140px;
            height: 140px;
          }
          .text{
            text-align: center;
            font-size: 18px;
            font-weight: 600;
            line-height: 36px;
          }
        }
      }
    }
  }
</style>

<template>
  <div class="download">
    <div class="bgImg">
      <div class="loadType">
        <div class="ios">
          <img class="ios_img" src="../../assets/imgs/syzg_js_ios.png" alt="" />
          <div class="text">IOS</div>
        </div>
        <div class="android">
          <img class="android_img" src="../../assets/imgs/syzg_js_android.png" alt="" />
          <div class="text">Android</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Download'

}
</script>
